import { useEffect, useState } from "react";
import { UrlApi } from "../../../services/apirest";

// Datos del reparto (planilla, chofer, patente) a partir del nro_reparto (uuid) del pedido.
// Endpoint /granel_pedidos/reparto (copia del que usa la tarjeta "Rendición" del detalle). Cada reparto se pide una sola vez:
// la consulta queda guardada y la comparten todas las filas del mismo reparto.
const consultas = new Map(); // nro_reparto -> Promise<reparto | null>

const obtenerReparto = (nroReparto) => {
  if (!consultas.has(nroReparto)) {
    const consulta = fetch(UrlApi + "/granel_pedidos/reparto/" + nroReparto)
      .then((res) => res.json())
      .then((data) => (Array.isArray(data) ? data[0] || null : null))
      .catch(() => {
        // Si falla, se olvida para reintentar la próxima vez que se muestre
        consultas.delete(nroReparto);
        return null;
      });
    consultas.set(nroReparto, consulta);
  }
  return consultas.get(nroReparto);
};

export default function useReparto(nroReparto) {
  const [reparto, setReparto] = useState(null);

  useEffect(() => {
    let vigente = true;
    setReparto(null);
    if (nroReparto) {
      obtenerReparto(nroReparto).then((datos) => {
        if (vigente) setReparto(datos);
      });
    }
    return () => {
      vigente = false;
    };
  }, [nroReparto]);

  return reparto;
}
